import cx from 'classnames';
import { MiniStroller, MiniStrollerPlaceholder } from 'mk2/apps/strollers/components/MiniStroller';
import { StrollerEntity } from 'mk2/apps/strollers/schemas';
import { strollersDetailUrl } from 'mk2/apps/strollers/urls';
import { Link } from 'mk2/components/Link';
import { url } from 'mk2/helpers/urls';
import React from 'react';
import styles from './ChartListItem.mscss';

interface OwnProps {
    className?: string;
    // NOTE: from StrollerEntity - do not use whole interface
    //  define only really needed values. It gives us much more
    //  freedom in tests and stories
    stroller: Pick<StrollerEntity, 'name' | 'slug' | 'userScore' | 'reviewsCount' | 'previewPhoto'>;
    position: number;
}

type Props = OwnProps;

export const ChartListItem: React.FunctionComponent<Props> = React.memo(({
    className, position, stroller,
}) => {
    return (
        <Link className={cx(styles.ChartListItem, className)} to={url(strollersDetailUrl, { slug: stroller.slug })}>
            <div className={styles.ChartListItem__position}>{position}</div>
            <MiniStroller className={styles.ChartListItem__stroller} stroller={stroller} />
        </Link>
    );
});

ChartListItem.displayName = 'ChartListItem';

interface PlaceholderOwnProps {
    className?: string;
    position: number;
}

export const ChartListItemPlaceholder: React.FunctionComponent<PlaceholderOwnProps> = ({ className, position }) => (
    <div className={cx(styles.ChartListItem, className)}>
        <div className={styles.ChartListItem__position}>{position}</div>
        <MiniStrollerPlaceholder className={styles.ChartListItem__stroller} />
    </div>
);

ChartListItemPlaceholder.displayName = 'ChartListItemPlaceholder';
